const MEL = "Australia/Melbourne";

const melParts = (date) => Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: MEL, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(date).map((p) => [p.type, p.value]));

// "YYYY-MM-DDTHH:MM" in Melbourne time — what the backend expects for starts_at_local.
export function melLocalInput(date = new Date()) {
  const p = melParts(date);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

// Melbourne calendar date "YYYY-MM-DD", offset by whole days.
export function melDate(offsetDays = 0) {
  const [y, m, d] = melLocalInput().slice(0, 10).split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + offsetDays)).toISOString().slice(0, 10);
}

export function formatAppointment(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  const part = (opts) => date.toLocaleString("en-AU", { timeZone: MEL, ...opts });
  return `${part({ weekday: "short" })} ${part({ day: "numeric" })} ${part({ month: "short" })}, ${part({ hour: "numeric", minute: "2-digit" })}`;
}
